import React, { Fragment } from 'react'
import CreateFeatureMutation from 'components/mutations/CreateFeature'
import FeatureIcon from 'components/icons/Feature'
import PageHeader from 'components/PageHeader'
import slugify from 'utils/slugify'
import { object, string } from 'yup'
import { ButtonLink, Form } from 'stylist'

const schema = object({
  name: string().required("Name can't be blank")
})

const RouteAdminFeaturesGlobalNew = () => (
  <Fragment>
    <PageHeader columns="auto 1fr">
      <PageHeader.Icon>
        <FeatureIcon size="1.75rem" />
      </PageHeader.Icon>
      <PageHeader.Title>New Feature</PageHeader.Title>
    </PageHeader>
    <article>
      <CreateFeatureMutation>
        {({ createFeature }) => (
          <Form
            initialValues={{ name: '' }}
            redirect="/admin/features/global"
            validationSchema={schema}
            onSubmit={createFeature}
          >
            <Form.Errors />
            <Form.Group>
              <Form.Label htmlFor="name">Name</Form.Label>
              <Form.Input
                type="text"
                name="name"
                formatValue={value => slugify(value, { separator: '_' })}
              />
            </Form.Group>
            <Form.Group buttons>
              <ButtonLink kind="ghost" to="/admin/features/global">
                Cancel
              </ButtonLink>
              <Form.SubmitButton>Submit</Form.SubmitButton>
            </Form.Group>
          </Form>
        )}
      </CreateFeatureMutation>
    </article>
  </Fragment>
)

export default RouteAdminFeaturesGlobalNew



// WEBPACK FOOTER //
// ./src/routes/admin/features/global/new.js